import React, {
  useContext,
  // useEffect
} from 'react';
import { useForm } from 'react-hook-form';
import { useHistory, useParams } from 'react-router-dom';
import {
  FormErrorMessage,
  FormLabel,
  FormControl,
  Textarea,
  Button,
  Box,
  useToast,
} from '@chakra-ui/react';

import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { HttpContext } from '../../context/HttpContext';
import { getMessage } from '../../util';
import { AuthContext } from '../../context/AuthContext';
import { SINGLE_CAMPAIGN_REQUEST_CHANGES_PAGE } from '../../pages/campaign/CampaignRequestChangesPage';

const RequestChangesCampaignForm = ({
  onClose,
  updateActivityLog,
  refreshCampaignAndActivity,
  parent,
}) => {
  const { id } = useParams();
  const history = useHistory();
  const auth = useContext(AuthContext);
  const [done, setDone] = React.useState(false);

  const validationSchema = Yup.object().shape({
    comment: Yup.string()
      .required('This is mandatory field')
      .test('len', 'Please enter 1000 characters or less', (val) => val.length < 1000),
  });

  const {
    register,
    handleSubmit,
    formState,
    // reset,
    // setError, watch
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
  });

  const { errors, isSubmitting, isDirty, isValid } = formState;
  const toast = useToast();
  const { authAxios } = useContext(HttpContext);
  const onSubmit = async (values) => {
    try {
      let url = `/campaigns/${id}/comments-by-pod-leader`;
      let submittedData = { commentByPodLeader: values.comment };

      if (auth.isFinance()) {
        url = `/campaigns/${id}/comments`;
        submittedData = { commentByFinance: values.comment };
      }

      const { data } = await authAxios.post(url, submittedData);
      setDone(true);
      onClose();
      if (typeof updateActivityLog === 'function') {
        updateActivityLog(data);
      }
      if (typeof refreshCampaignAndActivity === 'function') {
        refreshCampaignAndActivity();
      }
      if (parent === SINGLE_CAMPAIGN_REQUEST_CHANGES_PAGE) {
        toast({
          position: 'top',
          description: `You have successfully requested campaign changes.`,
          status: 'success',
          duration: 6000,
          isClosable: true,
        });
        history.push(`/campaigns/${id}`);
      }
    } catch (onError) {
      console.log(onError);
      const message = getMessage(onError);
      if (message) {
        toast({
          position: 'top',
          description: message,
          status: 'error',
          duration: 6000,
          isClosable: true,
        });
      }
      if (onError?.response?.status === 403) {
        toast({
          position: 'top',
          description: 'Access denied.',
          status: 'error',
          duration: 6000,
          isClosable: true,
        });
      }
      if (onError?.response?.status === 500) {
        toast({
          position: 'top',
          description: 'Something went wrong',
          status: 'error',
          duration: 6000,
          isClosable: true,
        });
      }
      setDone(true);
      onClose();
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl isInvalid={errors.comment} mb={[4, 4, 8]}>
          <FormLabel htmlFor="emailHtmlFor">Comment</FormLabel>
          <Textarea
            isInvalid
            name="comment"
            id="comment"
            size="lg"
            border="1px solid  transparent"
            bg="#ebecf0"
            _focus={{ border: '1px solid black' }}
            _hover={{ border: '1px solid black' }}
            {...register('comment')}
            placeholder="Enter your comment"
          />
          <FormErrorMessage>{errors.comment?.message || errors.comment}</FormErrorMessage>
        </FormControl>
        <>
          <Box d="flex" justifyContent="flex-end" mt={20} mb={20}>
            <Button
              type="submit"
              size="lg"
              colorScheme="brand"
              isLoading={isSubmitting && !done}
              disabled={!isDirty || !isValid || isSubmitting}
              textTransform="initial"
              _hover={{ bg: '#000' }}
              borderRadius="10px"
              mr="10px"
            >
              Submit
            </Button>
            <Button
              variant="ghost"
              size="lg"
              colorScheme="brand"
              textTransform="initial"
              borderRadius="10px"
              onClick={onClose}
            >
              Cancel
            </Button>
          </Box>
        </>
      </form>
    </>
  );
};
export default RequestChangesCampaignForm;
